import { render, staticRenderFns } from "./payStatus.vue?vue&type=template&id=1def7fc2&scoped=true&"
import script from "./payStatus.vue?vue&type=script&lang=js&"
export * from "./payStatus.vue?vue&type=script&lang=js&"
import style0 from "./payStatus.vue?vue&type=style&index=0&id=1def7fc2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1def7fc2",
  null
  
)

export default component.exports